'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = Row;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function Row(_ref) {
  var children = _ref.children;
  var _ref$className = _ref.className;
  var className = _ref$className === undefined ? '' : _ref$className;
  var _ref$style = _ref.style;
  var style = _ref$style === undefined ? {} : _ref$style;

  return _react2['default'].createElement(
    'div',
    { className: (0, _classnames2['default'])('row', className), style: style },
    children
  );
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lib/components/row.js
// module id = 334
// module chunks = 0